import React from 'react';
import { RatingNumber, StarWrapper, Wrap } from './styles';
import Star from '@/components/atoms/Star/Star';

interface StarRatingProps {
	rating: number;
	children?: React.ReactNode;
	ratingPercent?: number,
}

const StarRating: React.FC<StarRatingProps> = ({ rating, children, ratingPercent = 0 }) => {
	const index = 0;
	return (
		<Wrap>
			<StarWrapper>
				<Star fillPercentage={ratingPercent} index={index} transparent />
			</StarWrapper>
			{children && <RatingNumber>{children}</RatingNumber>}
		</Wrap>
	);
};

export default StarRating;